// about
// global_nav
// home
// input
// investors
// nft
// press
// stacked_menu

import yolo_nft_silver_512 from './files/nft/yolo_nft-silver-512.png'
import yolo_nft_ruby_512 from './files/nft/yolo_nft-ruby-512.png'
import yolo_nft_rose_512 from './files/nft/yolo_nft-rose-512.png'
import yolo_nft_orchid_512 from './files/nft/yolo_nft-orchid-512.png'
import yolo_nft_gold_512 from './files/nft/yolo_nft-gold-512.png'
import yolo_nft_emerald_512 from './files/nft/yolo_nft-emerald-512.png'
import yolo_nft_diamond_512 from './files/nft/yolo_nft-diamond-512.png'
import yolo_nft_blue_512 from './files/nft/yolo_nft-blue-512.png'

import yolorekt_moon_white from './files/stacked_menu/yolorekt_moon-white.svg'
import xft_icon_only from './files/stacked_menu/xft_icon-only.svg'
import user_icon from './files/stacked_menu/user_icon.svg'
import tour_icon from './files/stacked_menu/tour_icon.svg'
import support_icon from './files/stacked_menu/support_icon.svg'
import referral_icon from './files/stacked_menu/referral_icon.svg'
import press_icon from './files/stacked_menu/press_icon.svg'
import liquidity_dashboard_icon from './files/stacked_menu/liquidity_dashboard_icon.svg'
import leader_icon from './files/stacked_menu/leader_icon.svg'
import docs_icon from './files/stacked_menu/docs_icon.svg'
import contest_icon from './files/stacked_menu/contest_icon.svg'
import careers_icon from './files/stacked_menu/careers_icon.svg'
import bidders_dashboard_icon from './files/stacked_menu/bidders_dashboard_icon.svg'
import bidders_dashboard_icon_2 from './files/stacked_menu/bidders_dashboard_icon_2.svg'
import cube_white_icon from './files/stacked_menu/cube_white_icon.png'

import pantera_cap_logo_color_circle from './files/investors/pantera_cap_logo-color-circle.png'
import jack_herrick from './files/investors/jack_herrick.jpg'
import josh_hannah from './files/investors/josh_hannah.jpg'
import angeldao_logo_bw from './files/investors/angeldao_logo-bw.png'
import angeldao_logo_color from './files/investors/angeldao_logo-color.png'
import cluster_bw_circle from './files/investors/cluster-bw-circle.png'
import cluster_color_circle from './files/investors/cluster-color-circle.png'
import deepventures_bw_circle from './files/investors/deepventures-bw-circle.png'
import deepventures_color_circle from './files/investors/deepventures-color-circle.png'
import jack_herrick_bw_circle from './files/investors/jack_herrick-bw-circle.png'
import jack_herrick_bw from './files/investors/jack_herrick-bw.png'
import jack_herrick_color_circle from './files/investors/jack_herrick-color-circle.png'
import josh_hannah_bw_circle from './files/investors/josh_hannah-bw-circle.png'
import josh_hannah_bw from './files/investors/josh_hannah-bw.png'
import josh_hannah_color_circle from './files/investors/josh_hannah-color-circle.png'
import lemniscap_logo_bw from './files/investors/lemniscap_logo-bw.png'
import lemniscap_logo_color from './files/investors/lemniscap_logo-color.png'
import pantera_cap_logo_bw_circle from './files/investors/pantera_cap_logo-bw-circle.png'
import pantera_cap_logo_bw from './files/investors/pantera_cap_logo-bw.png'
import pantera_cap_logo from './files/investors/pantera_cap_logo.png'
import kretos_logo from './files/investors/kretos_logo.svg'
import lemniscap_logo from './files/investors/lemniscap_logo.svg'
import immunefi_logo_white from './files/immunefi_logo_white.svg'

// import tme_lp from './files/tme_lp.gif'
// import tpe_lp from './files/tpe_lp.gif'
import bidders_screenshot from './files/bidders_screenshot.jpg'
import liquidity_screenshot from './files/liquidity_screenshot.jpg'
import litepaper_bg from './files/litepaper_bg.jpg'
import beta_badge_large from './files/beta_badge_large.png'
import beta_badge from './files/beta_badge.png'
import coinbase_icon from './files/coinbase_icon.png'
import dual_issuance from './files/dual_issuance.png'
import eth_home_icon from './files/eth-home-icon.png'
import litepaper_icon from './files/litepaper_icon.png'
import live_graph_temp from './files/live_graph_temp.png'
import yolo_nft_diamond from './files/yolo_nft-diamond.png'
import yolo_nft_emerald from './files/yolo_nft-emerald.png'
import yolo_nft_gold from './files/yolo_nft-gold.png'
import yolo_nft_orchid from './files/yolo_nft-orchid.png'
import yolo_nft_rose from './files/yolo_nft-rose.png'
import yolo_nft_ruby from './files/yolo_nft-ruby.png'
import yolo_nft_silver from './files/yolo_nft-silver.png'
import about_icon from './files/about_icon.svg'
import alert_icon_red from './files/alert_icon-red.svg'
import arrow_up from './files/arrow_up.svg'
import check_icon_blue from './files/check_icon-blue.svg'
import check_icon from './files/check_icon.svg'
import close_window_icon_2 from './files/close_window_icon_2.svg'
import close_window_icon from './files/close_window_icon.svg'
import copy_icon from './files/copy_icon.svg'
import discord_icon from './files/discord_icon.svg'
import email_icon from './files/email_icon.svg'
import equal_icon from './files/equal_icon.svg'
import equal_thin_icon from './files/equal_thin_icon.svg'
import eth_icon from './files/eth_icon.svg'
import etherium_icon from './files/etherium_icon.svg'
import gemini_icon from './files/gemini_icon.svg'
import live_bids_meter from './files/live_bids_meter.svg'
import live_text from './files/live_text.svg'
import medium_icon from './files/medium_icon.svg'
import metamask_icon from './files/metamask_icon.svg'
import meter_needle from './files/meter_needle.svg'
import minus_icon from './files/minus_icon.svg'
import pending_icon_yellow from './files/pending_icon-yellow.svg'
import pending_icon from './files/pending_icon.svg'
import plus_icon from './files/plus_icon.svg'
import polygon_icon from './files/polygon_icon.svg'
import project_galaxy_logo_white_hor from './files/project_galaxy_logo-white-hor.svg'
import swap_icon from './files/swap_icon.svg'
import telegram_icon from './files/telegram_icon.svg'
import tesla_icon from './files/tesla_icon.svg'
import tiktok_icon from './files/tiktok_icon.svg'
import trustwallet_icon from './files/trustwallet_icon.svg'
import twitter_icon from './files/twitter_icon.svg'
import unstoppable_domains_logo_dark from './files/unstoppable_domains_logo-dark.svg'
import usd_icon_2 from './files/usd_icon_2.svg'
import usd_icon from './files/usd_icon.svg'
import wallet_icon from './files/wallet_icon.svg'
import walletconnect_icon from './files/walletconnect_icon.svg'
import yolo_nft_blue from './files/yolo_nft-blue.svg'
import yolo_token from './files/yolo_token.svg'
import yolorekt_logo_new_h1_white from './files/yolorekt_logo_new_h1_white.svg'
import yolorekt_logo_welcome from './files/yolorekt_logo-welcome.svg'
import yolo_wallet_page_screenshot from './files/yolo_wallet_page_screenshot.jpg'

export const landingAssets = {
  yolo_nft_silver_512,
  yolo_nft_ruby_512,
  yolo_nft_rose_512,
  yolo_nft_orchid_512,
  yolo_nft_gold_512,
  yolo_nft_emerald_512,
  yolo_nft_diamond_512,
  yolo_nft_blue_512,

  yolorekt_moon_white,
  xft_icon_only,
  user_icon,
  tour_icon,
  support_icon,
  referral_icon,
  press_icon,
  liquidity_dashboard_icon,
  leader_icon,
  docs_icon,
  contest_icon,
  careers_icon,
  bidders_dashboard_icon,
  bidders_dashboard_icon_2,
  cube_white_icon,

  pantera_cap_logo_color_circle,
  jack_herrick,
  josh_hannah,
  angeldao_logo_bw,
  angeldao_logo_color,
  cluster_bw_circle,
  cluster_color_circle,
  deepventures_bw_circle,
  deepventures_color_circle,
  jack_herrick_bw_circle,
  jack_herrick_bw,
  jack_herrick_color_circle,
  josh_hannah_bw_circle,
  josh_hannah_bw,
  josh_hannah_color_circle,
  lemniscap_logo_color,
  pantera_cap_logo_bw_circle,
  pantera_cap_logo_bw,
  pantera_cap_logo,
  kretos_logo,
  lemniscap_logo_bw,
  lemniscap_logo,

  // tme_lp,
  // tpe_lp,
  bidders_screenshot,
  liquidity_screenshot,
  litepaper_bg,
  about_icon,
  beta_badge_large,
  beta_badge,
  coinbase_icon,
  dual_issuance,
  eth_home_icon,
  litepaper_icon,
  live_graph_temp,
  yolo_nft_diamond,
  yolo_nft_emerald,
  yolo_nft_gold,
  yolo_nft_orchid,
  yolo_nft_rose,
  yolo_nft_ruby,
  yolo_nft_silver,
  alert_icon_red,
  arrow_up,
  check_icon_blue,
  check_icon,
  close_window_icon_2,
  close_window_icon,
  copy_icon,
  discord_icon,
  email_icon,
  equal_icon,
  equal_thin_icon,
  eth_icon,
  etherium_icon,
  gemini_icon,
  live_bids_meter,
  live_text,
  medium_icon,
  metamask_icon,
  meter_needle,
  minus_icon,
  pending_icon_yellow,
  pending_icon,
  plus_icon,
  polygon_icon,
  project_galaxy_logo_white_hor,
  swap_icon,
  telegram_icon,
  tesla_icon,
  tiktok_icon,
  trustwallet_icon,
  twitter_icon,
  unstoppable_domains_logo_dark,
  usd_icon_2,
  usd_icon,
  wallet_icon,
  walletconnect_icon,
  yolo_nft_blue,
  yolo_token,
  yolorekt_logo_new_h1_white,
  yolorekt_logo_welcome,
  immunefi_logo_white,
  yolo_wallet_page_screenshot,
}
